import { FC, ReactNode, createContext, useContext } from 'react';
import { IStore, stateStore } from 'store/state';
import { useStore } from 'zustand';

interface IProvider {
  children: ReactNode;
}

const StoreStateContext = createContext<IStore | undefined>(undefined);

export const StoreStateProvider: FC<IProvider> = ({ children }) => {
  const value = useStore(stateStore);

  return <StoreStateContext.Provider value={value}>{children}</StoreStateContext.Provider>;
};

export const useStoreState = () => {
  const context = useContext(StoreStateContext);
  if (!context) {
    throw new Error('useStoreState must be used within an StoreStateProvider');
  }
  return context;
};
